import React, { useState, useEffect } from 'react';
import { get } from '../common/httpService';
import common from '../common/common';

function UserIcon(props) {
    const [user, setUser] = useState({
        isAuthenticated: false,
        firstName: '',
        profileUrl: '',
        ordersUrl: '',
    });

    async function getUser() {
        try {
            get({
                url: `account/getUserHeader`,
            }).then((data) => {
                setUser(data);
            });
        } catch (e) {
            console.log(e.status);
            setUser({
                isAuthenticated: false,
                firstName: '',
                profileUrl: '',
                ordersUrl: '',
            });
        }
    }

    useEffect(() => {
        getUser();
    }, []);

    return user.isAuthenticated ? (
        <a href={user.profileUrl} className='usericon'>
            <img
                src={common.contentFromCdn({
                    path: `/content/img/user-logged.svg`,
                    keepUrlAsIs: false,
                })}
                type='image/svg+xml'
                alt='user logged'
            />
        </a>
    ) : (
        <a
            href={common.getSiteUrl(`${window.$pathBase}Account/LogOn`)}
            className='usericon'>
            <img
                src={common.contentFromCdn({
                    path: `/content/img/user.svg`,
                    keepUrlAsIs: false,
                })}
                type='image/svg+xml'
                alt='user'
            />
        </a>
    );
}

export default UserIcon;
